export default {
  songPage: {
    tabs: {
      infos: 'Info',
      chords: 'Chords / Hand shapes',
      rhythmics: 'Rhythms',
      lyrics: 'Lyrics',
      skills: 'Skills'
    },
    songUnavailable: 'Sorry, this song does not seem available at the moment. Please try again later.'
  },
  
  versionInfosPanel: {
    play: 'Play',
    partition: 'Sheet music',
    piano: 'Piano ',
    syncPianoVoice: 'Piano-voice sync',
    tempo: 'Tempo:',
    style: 'Style:',
    score: 'Score:',
    pieceContains: 'The piece contains:',
    editLyrics: 'Edit lyrics',
    optionReservedPremium: 'This option is reserved for members with a premium subscription.',
    subscribe: 'Subscribe',
    noPartitionAvailable: 'No sheet music for this piece',
    mainRhythmics: 'main rhythms',
    of: 'of which',
    known: 'known and',
    mastered: 'mastered.',
    handprints: 'hand shapes',
  },
  
  chordsTab: {
    chords: 'Chords',
    handprints: 'Hand shapes',
    displayOf: 'Display of',
    hands: 'Hands',
    bothHands: 'Both hands',
    leftHand: 'Left hand',
    rightHand: 'Right hand'
  },
  
  lyricsTab: {
    noLyricsInPart: 'No lyrics in this part'
  },
  
  skillsTab: {
    noSkillsAssociated: 'No skills associated with this piece.',
    sortByMastery: 'By mastery',
    sortByDifficulty: 'By difficulty',
  },
  
  infosTab: {
    structureAndProgress: 'Piece structure and progress',
    structure: 'Structure',
    resume: 'Resume',
    otherVersions: 'Other versions',
    associatedChallenges: 'Associated challenges',
    summary: 'Summary',
    skills: 'skill{plural}',
    recognize: 'recognized',
    validated: 'validated',
    inProgress: 'in progress',
    notStarted: 'to work on',
    blocked: 'blocked',
    noSkills: "No skills associated with this piece."
  },
  
  rhythmicsTab: {
    noRhythmics: 'No rhythms'
  },
  
  songPlayability: {
    playability: 'Playability',
    pieceRangeDescription: 'This piece goes from <b>{minKey}</b> to <b>{maxKey}</b> over <b>{octaves} octaves</b> and therefore requires a keyboard with at least <b>{keys}</b> keys.'
  },
  
  linkedPlayableList: {
    noContentAvailable: 'No content available',
  },
  downloadPartitionPage: {
    downloading: 'Downloading sheet music...',
    downloadCompleted: 'Sheet music download completed',
    downloadFailed: 'Sheet music download failed',
    back: 'Back',
    downloadError: 'Error downloading sheet music',
  },
  versionType: {
    inspired: 'Inspired version',
    simplified: 'Simplified version',
    original: 'Original version',
  },
  partClassesList: {
    fullPieceConsolidation: 'Play full piece',
  },
};